import React from 'react';

export default ({color}: {color: string}) => (
    <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="3.2251" cy="3.97461" r="3" fill={color} />
    </svg>
);
